import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DmcPackageService {

  private _dmcApiUrl = `${environment.dmc}/dmcoffers`;

  constructor(
    private _http: HttpClient
  ) { }

  getAllPackages(pageNumber: any, pageSize:any, searchKeyword:any, organizationId: any, filters: any): Observable<any>{
    const paginationSettings = {
      pageNumber: pageNumber || 1,
      pageSize: pageSize || 10,
      search: searchKeyword || "",
      filters: filters
    }
    return this._http.post<any>(`${this._dmcApiUrl}?organizationId=${organizationId}`, paginationSettings);
  }
  getPackage(dmcPackageId: any, organizationId:any): Observable<any>{
    if(!organizationId){
      organizationId = "";
    }
    return this._http.get<any>(`${this._dmcApiUrl}/dmcoffer/${dmcPackageId}/${organizationId}`);
  }
  getPackageWithPassengers(dmcPackageId:any, totalPassengers:any, organizationId:any): Observable<any>{
    if(!organizationId){
      organizationId = "";
    }
    return this._http.get<any>(`${this._dmcApiUrl}/dmcoffer/${dmcPackageId}/${organizationId}?passengers=${totalPassengers}`);
  }
  deletePackage(dmcPackageId: any): Observable<any>{
    return this._http.delete<any>(`${this._dmcApiUrl}/dmcoffer/${dmcPackageId}`);
  }
  addPackageDetails(formData: any): Observable<any>{
    return this._http.post<any>(`${this._dmcApiUrl}/adddmcpackage`, formData);
  }

  addHotelPricing(formData: any): Observable<any>{
    return this._http.post<any>(`${this._dmcApiUrl}/addhotelpricing`, formData);
  }

  addInclusionAndExclusion(formData: any): Observable<any>{
    return this._http.post<any>(`${this._dmcApiUrl}/addinclusionandexclusion`, formData);
  }

  addTermsAndConditions(formData: any): Observable<any>{
    return this._http.post<any>(`${this._dmcApiUrl}/addtermsandcondition`, formData);
  }

  addCancellationPolicy(formData: any): Observable<any>{
    return this._http.post<any>(`${this._dmcApiUrl}/addcancellationpolicy`, formData);
  }

  addImportantInformation(formData: any): Observable<any>{
    return this._http.post<any>(`${this._dmcApiUrl}/addimportantinformation`, formData);
  }

  addNotes(formData: any): Observable<any>{
    return this._http.post<any>(`${this._dmcApiUrl}/addnotes`, formData);
  }

  addRouteCraft(formData: any): Observable<any>{
    return this._http.post<any>(`${this._dmcApiUrl}/addroutecraft`, formData);
  }
  
  addTransfers(formData: any): Observable<any>{
    return this._http.post<any>(`${this._dmcApiUrl}/addtransfers`, formData);
  }

  uploadTransfersImage(formData:any): Observable<any>{
    return this._http.post<any>(`${this._dmcApiUrl}/uploadimage`, formData);
  }

  addOptionalSightseeing(formData: any): Observable<any>{
    return this._http.post<any>(`${this._dmcApiUrl}/addoptionalsightseeing`, formData);
  }

  getPackageTemplate(packageId: string, organizationId:any): Observable<any>{
    if(!organizationId){
      organizationId = "";
    }
    return this._http.get<any>(`${environment.inventory}/dmctemplate/${packageId}/${organizationId}`, { responseType: 'text' as 'json' });
  }

  performBulkActions(req:any): Observable<any>{
    return this._http.put<any>(`${environment.dmc}/updatedmcs`, req)
  }

  updateTemplateDetails(packageId: any, formData: FormData): Observable<any> {
    return this._http.put<any>(`${environment.inventory}/dmcpackagetemplates/${packageId}`, formData);
  }

  clonePackage(packageId:any){
    return this._http.post<any>(`${environment.dmc}/CloneDmcPackage/${packageId}`, {})
  }
}
